import http from './httpService'
import config from './config.json'

export const sendCodeFinoTech=()=>{
    return http.post(`${config.coinbaseapiopt}/otp-token-request`)
}

export const confirmCodeFinoTech=obj=>{
    return http.post(`${config.coinbaseapiopt}/confirm-otp`,obj)
}